import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPointsSection() {
  const points = ['Querés empezar en detailing pero no sabés por dónde', 'Ves videos… pero cada uno dice algo distinto', 'No sabés qué comprar ni en qué orden', 'Tenés miedo de gastar mal o hacer un mal trabajo', 'Sentís que estás perdiendo tiempo sin avanzar'];
  return <section className="py-16 px-4 bg-[#111] border-y border-gray-800 pt-[36px] pb-[36px] pl-[14px] pr-[14px] mt-[0px] mb-[0px]" data-id="element-162">
      <div className="max-w-3xl mx-auto" data-id="element-163">
        <h2 className="md:text-4xl font-bold text-center mb-10 text-brand-yellow text-[24px]" data-id="element-164">
          Si te sentís así, esto es para vos
        </h2>

        <div className="space-y-4 md:space-y-6" data-id="element-165">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-5 md:p-6 rounded-xl border border-gray-800 shadow-lg bg-[#000000]" data-id="element-166">
              <XCircle className="w-7 h-7 md:w-8 md:h-8 text-red-500 flex-shrink-0 mt-0.5" data-id="element-167" />
              <p className="text-lg md:text-xl text-gray-200 font-medium" data-id="element-168">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center bg-brand-yellow/10 py-6 px-4 rounded-2xl border border-brand-yellow/20" data-id="element-169">
          <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-170">
            👉 No estás solo.{' '}
            <span className="text-brand-yellow" data-id="element-171">
              Te falta un sistema claro.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}